import React from 'react';
import CopyrightTwo from "./CopyrightTwo";
import ScrollTop from "./ScrollTop";


const FooterThreeAlt = () => {
    return (
        <>
            <div className="footer-style-2">
                <CopyrightTwo />
            </div>
            <ScrollTop />
        </>
    )
}
export default FooterThreeAlt;